/**
 * @description Hook utilizado para manipular o exame de Eficiência
 * @author Diego Sabino Amorim de Araújo
 * @file useExameEficienciaService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { setProcessando } from 'actions'
import { useFetch } from './useFetch'

export const useExameEficienciaService = () => {
  const fetch = useFetch()

  const cadastrarAnaliseEficiencia = async (idDescricaoTecnica, idExameRealizado, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosCadastro = {
        id_exame_eficiencia: idExameRealizado,
        id_descricao_tecnica_vestigio: idDescricaoTecnica,
        resultado: dados.resultado,
      }
      await fetch.postOpen(`/exameEficienciaBalistica/analiseEficiencia`, dadosCadastro)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarAnaliseQuimicoMetalografico = async (idDescricaoTecnica, idExameRealizado, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosCadastro = {
        id_exame_realizado: idExameRealizado,
        id_descricao_vestigio_balistico: idDescricaoTecnica,
        resultado: dados.resultado,
        numeroSerie: dados.numeroSerie,
        locGravs: dados.locGravs?.map((local) => local.id) || null,
      }
      await fetch.postOpen(`/exameEficienciaBalistica/analiseQuimicoMetalografico`, dadosCadastro)
    } catch (error) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarAnaliseRevelacaoFisicoQuimico = async (idDescricaoTecnica, idExameRealizado, dados, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const dadosCadastro = {
        id_exame_realizado: idExameRealizado,
        id_descricao_vestigio_balistico: idDescricaoTecnica,
        resultado: dados.resultado,
        numeroSerie: dados.numeroSerie,
        locGravs: dados.locGravs?.map((local) => local.id) || null,
      }
      await fetch.postOpen(`/exameEficienciaBalistica/analiseRevelacaoFisicoQuimico`, dadosCadastro)
    } catch (error) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarExameEficienciaAsync = async (idExameEficiencia, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameEficienciaBalistica/${idExameEficiencia}`)

      return response.data.exameEficiencia
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }
  return {
    cadastrarAnaliseEficiencia,
    cadastrarAnaliseQuimicoMetalografico,
    cadastrarAnaliseRevelacaoFisicoQuimico,
    listarExameEficienciaAsync,
  }
}
